export function isTruish(val: any) {
  return val === "true" || val === "1" || val === "yes" || val === true || val === 1;
}
